import axios from "axios"

export const api = axios.create({
  baseURL: "https://worker-proxy.anbeel191.workers.dev",
  headers: {
    "Content-Type": "application/json",
  },
})

export type CreateBookingRequest = {
  dia_diem: "tan_dinh" | "thu_duc"
  so_luong_khach: number
  ngay: string // dd-mm-yyyy
  thoi_gian: string // HH:mm
  ten: string
  so_dien_thoai: string
  khu_vuc?: "phong_lanh" | "ngoai_troi" // Seating area
  platform?: "fb" | "tiktok" | null // Platform source from cookie
}

export async function createBooking(payload: CreateBookingRequest) {
  const res = await api.post("/dat-ban", payload)
  return res.data
}
